export default "__VITE_ASSET__b13ce070__"